import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserPreferencesCacheService } from '../shared/services/user-preferences-cache.service';

@Injectable({
    providedIn: 'root',
})
export class CpfRequiredGuard implements CanActivate {
    constructor(
        private userCacheService: UserPreferencesCacheService,
        private router: Router
    ) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        const currentUrl = state.url;


        try {
            const user = await firstValueFrom(this.userCacheService.getUser());
            if (user && !user.cpf) {
                this.router.navigate(['/my-account/user']);
                return false;
            }
        } catch {
            // Em caso de erro na API, não bloquear o acesso
            return true;
        }

        return true;
    }
}
